<mat-toolbar class="stick-top">
  <mat-icon>add</mat-icon>
  Add Product Type
</mat-toolbar>
<div class="hbox lightly-padded button-bar">
  <button mat-raised-button class="primary" type="button" (click)="add()" [disabled]="!itsmCarrierId || !form.form.valid">
    Add
  </button>
</div>

<form #form="ngForm" role="form">
<div class="padded vbox vbox-space">
  <div *ngIf="productType">
    <table class="basicTable">
      <thead>
      <tr>
        <th colspan="100">ProductType Detail</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th>Carrier</th><td><micro-itsmCarrier-select [(itsmCarrierId)]="itsmCarrierId" [required]="true"></micro-itsmCarrier-select></td>
      </tr>
      <tr>
        <th>Name</th><td><input [(ngModel)]="productType.name" required id="title" name="title"/></td>
      </tr>
      <tr>
      </tbody>
    </table>
  </div>
</div>
</form>
